import React from "react";
import styles from "./RatingSelector.module.css";

const RatingSelector = ({ selectedRating = 0, onRatingSelect }) => {
  const handleToggle = () => {
    const newRating = selectedRating === 4 ? 0 : 4;
    onRatingSelect?.(newRating);
  };

  return (
    <div className={styles.ratingContainer}>
      <div className={styles.stars}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star} className={`${styles.star} ${star !== 5 ? styles.filled : ""}`}>
            ★
          </span>
        ))}
        <span className={styles.text}>& Up</span>
      </div>

      {/* Toggle Switch */}
      <label className={styles.toggleContainer}>
        <input type="checkbox" checked={selectedRating === 4} onChange={handleToggle} />
        <span className={styles.checkmark}></span>
      </label>
    </div>
  );
};

export default RatingSelector;
